export const OPTIONS_STAGE = [
  { value: "assigned", label: "รอรับงาน" },
  { value: "received", label: "รับงานแล้ว" },
];

export const OPTIONS_STAGE_WITH_ALL = [
  { value: "all", label: "ทั้งหมด" },
  ...OPTIONS_STAGE,
];

export const getCaseTypeMeta = (flagLoanNew, flagDue) => {
  if (flagLoanNew === 1) return { color: "blue", label: "ทำยอม" };
  if (flagLoanNew === 2 && flagDue === 1)
    return { color: "purple", label: "พิพากษามีดิว" };
  return { color: "default", label: "พิพากษาปกติ" };
};

export const getStageKey = (r) => (r.receiveDate ? "received" : "assigned");

export const getStageMeta = (r) => {
  const key = getStageKey(r);
  if (key === "received") return { color: "green", label: "รับงานแล้ว" };
  return { color: "orange", label: "รอรับงาน" };
};

export const getCaseTypeLabel = (flagLoanNew, flagDue) =>
  flagLoanNew === 1
    ? "ทำยอม"
    : flagLoanNew === 2 && flagDue === 0
      ? "พิพากษาปกติ"
      : flagLoanNew === 2 && flagDue === 1
        ? "พิพากษาปกติมีตารางดิว"
        : "-";

// 1 ที่ดิน(สืบออนไลน์พบ) / 2 อายัดเงินได้ / 3 รถนอกสัญญา / 4 รถในสัญญา / 5 ที่ดินในสัญญา
export const ASSET_TYPE_META = {
  1: { label: "ที่ดิน (สืบออนไลน์พบ)", isLand: true },
  2: { label: "อายัดเงินได้" },
  3: { label: "รถนอกสัญญา", isVehicle: true },
  4: { label: "รถในสัญญา", isVehicle: true },
  5: { label: "ที่ดินในสัญญา", isLand: true },
};

export const getAssetTypeMeta = (typeAsset) =>
  ASSET_TYPE_META[typeAsset] || { label: "ไม่ระบุ" };

// โซนระยะทาง: 1=(0-150กม.) / 2=(151-300กม.) / 3=(301-500กม.) / 4=(501-800กม.) / E=(800กม.ขึ้นไป)
export const getDistanceZone = (distance) => {
  if (distance == null) return null;
  if (distance <= 1) return 150;
  if (distance <= 2) return 300;
  if (distance <= 3) return 500;
  if (distance <= 4) return 800;
  return "E";
};

export const OPTIONS_ZONE = [
  { value: 150, label: "โซน 1 (0-150 กม.)" },
  { value: 300, label: "โซน 2 (151-300 กม.)" },
  { value: 500, label: "โซน 3 (301-500 กม.)" },
  { value: 800, label: "โซน 4 (501-800 กม.)" },
  { value: 1000, label: "โซน 5 (800 กม. ขึ้นไป)" },
];

// แหล่งที่มาของสัญญาที่จะเลือกลงพื้นที่
// all / inContract = ทรัพย์ในสัญญา (4,5) / found = สืบทรัพย์เจอ (1,2,3) / idCard = จังหวัดตามบัตรประชาชน
export const CONTRACT_SOURCE = {
  all: { label: "ทั้งหมด", icon: "📋", typeAssets: [1, 2, 3, 4, 5] },
  inContract: { label: "ทรัพย์ในสัญญา", icon: "🏠", typeAssets: [4, 5] },
  found: { label: "สืบทรัพย์เจอ", icon: "🔎", typeAssets: [1, 2, 3] },
  idCard: { label: "จังหวัดตามบัตร", icon: "🪪" },
};

// เลขบัตรประชาชน หลักที่ 2-3 = รหัสจังหวัด, หลักที่ 4-5 = รหัสอำเภอ
export const parseIdCardArea = (cuscod) => {
  const s = String(cuscod ?? "").trim();
  if (!/^\d{13}$/.test(s)) return null;
  return { province: s.slice(1, 3), district: s.slice(3, 5) };
};
